module.exports = __webpack_public_path__ + "static/cely_rose_bebe_3-cf8bae6f29874c67a50970ad7ae1d91b.jpg";